import React, { ReactNode } from 'react';

import { Responsive } from '@portals/core';
import { Auth, DashboardLayout, MobileSupport } from '@portals/framework';

interface LayoutProps {
  children: ReactNode;
}

export function DashboardLayoutWrapper({ children }: LayoutProps) {
  return (
    <Responsive>
      <Responsive.Desktop>
        <DashboardLayout>{children}</DashboardLayout>
      </Responsive.Desktop>

      <Responsive.Mobile>
        <MobileSupport />
      </Responsive.Mobile>
    </Responsive>
  );
}

export function AuthLayoutWrapper({ children }: LayoutProps) {
  return (
    <Responsive>
      <Responsive.Desktop>
        <Auth>{children}</Auth>
      </Responsive.Desktop>

      <Responsive.Mobile>
        <MobileSupport />
      </Responsive.Mobile>
    </Responsive>
  );
}
